import { confirmApp } from '../common/appDialog';
import React from 'react';
import type { EpProject } from '@types';
import { ICONS } from './constants';

interface EpDashboardProps {
    projects: EpProject[];
    onSelectProject: (projectId: string) => void;
    onCreateProject: () => void;
    onDeleteProject: (projectId: string) => void;
}

const EpDashboard: React.FC<EpDashboardProps> = ({ projects, onSelectProject, onCreateProject, onDeleteProject }) => {
    return (
        <div className="animate-fade-in">
            <h2 className="text-2xl font-bold text-slate-800">Executive Protection Projects</h2>
            <p className="text-slate-500 mb-6">Select an existing project or create a new one to begin.</p>
            
            <div className="mb-6">
                <button
                    onClick={onCreateProject}
                    className="inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-md"
                >
                    {React.cloneElement(ICONS.folder_plus as any, { className: 'h-5 w-5 mr-2' })}
                    Create New Project
                </button>
            </div>

            <div className="space-y-3">
                {projects.length === 0 ? (
                    <p className="text-slate-500 text-center py-8">No projects found. Create one to get started.</p>
                ) : (
                    projects.map(project => (
                        <div key={project.id} className="group bg-white p-4 rounded-lg border border-slate-200 hover:shadow-md hover:border-blue-500 transition-all flex justify-between items-center">
                            <div className="flex items-center">
                                <div className="p-2 bg-slate-100 text-slate-600 rounded-lg mr-4">
                                    {React.cloneElement(ICONS.folder as any, { className: 'h-6 w-6' })}
                                </div>
                                <div>
                                    <p className="font-bold text-slate-800">{project.name || 'Untitled Project'}</p>
                                    <p className="text-sm text-slate-500">{project.id} &bull; Principal: {project.plannerData?.ep_pp_principal_name || 'N/A'}</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-2">
                                <button
                                    onClick={() => onSelectProject(project.id)}
                                    className="bg-slate-200 hover:bg-slate-300 text-slate-800 font-semibold py-1.5 px-4 rounded-md text-sm transition-colors"
                                >
                                    Open
                                </button>
                                <button
                                    onClick={async () => {
                                        if (await confirmApp(`Are you sure you want to delete "${project.name || project.id}"? This action cannot be undone.`)) {
                                            onDeleteProject(project.id);
                                        }
                                    }}
                                    className="p-2 text-slate-400 hover:text-red-600 hover:bg-red-100 rounded-full transition-colors opacity-0 group-hover:opacity-100"
                                    aria-label="Delete Project"
                                >
                                    {React.cloneElement(ICONS.trash as any, { className: 'h-5 w-5' })}
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default EpDashboard;
